export const getTokenFromCartId = (cartId: string) => {
  const cartToken = cartId?.split('?')[0].split('/').filter(Boolean).pop() || undefined;
  return cartToken;
};
